module.exports = __webpack_public_path__ + "images/help/icon-twr56-0a8a31bb672aa039de2238d9099babe2.png";